module.exports = __webpack_public_path__ + "static/media/minus.fb1f378b.svg";